// extracted by mini-css-extract-plugin
module.exports = {"section":"DescriptionSection_section_zbgGO","content":"DescriptionSection_content_3WnOM"};